import DataService from '@/services/DataService';
import SettingsService from '@/services/SettingsService';

const initialState = {
	dataElements: [],
	dataElement: {},

	chosenOptions: null,

	fetchSettingsData: true,
	familySettingsState: {},
	childSettingsState: {},

	settingsNotif: {}
};

const settingsStore = {
	namespaced: true,

	//#region [ State ]
	state: {
		...initialState
	},
	//#endregion

	//#region [ Mutations ]
	mutations: {
		setDataElements(state, payload) {
			state.dataElements = payload;
		},

		setDataElement(state, payload) {
			state.dataElement = payload;
		},

		reset(state) {
			Object.assign(state, initialState);
		},

		setChosenOptions(state, payload) {
			state.chosenOptions = payload;
		},

		setFamilySettings(state, payload) {
			state.familySettingsState = payload;
		},

		setChildSettings(state, payload) {
			state.childSettingsState = payload;
		},

		setFetchSettings(state, payload) {
			state.fetchSettingsData = payload;
		},

		setSettingsNotif(state, payload) {
			state.settingsNotif = payload;
		}
	},
	//#endregion

	//#region [ Actions ]
	actions: {
		async getDataElements({ commit }) {
			try {
				const res = await DataService.getAll();
				if (res.Code === 200) {
					commit('setDataElements', res.Data);
				}
				return res;
			} catch (error) {
				console.log(error);
			}
		},

		async getDataById({ commit }, id) {
			try {
				const res = await DataService.getDataById(id);
				if (res.Code === 200) {
					commit('setDataElement', res.Data);
				}
				return res;
			} catch (error) {
				console.log(error);
			}
		},

		resetSettingsStoreState({ commit }) {
			commit('reset');
		},

		// eslint-disable-next-line no-unused-vars
		async saveDataElement({ commit }, dataElement) {
			try {
				let res = await DataService.saveDataElement(dataElement);
				return res;
			} catch (error) {
				console.log(error);
			}
		},

		// eslint-disable-next-line no-unused-vars
		async updateDataElement({ commit }, dataElement) {
			try {
				let res = await DataService.updateDataElement(dataElement);
				return res;
			} catch (error) {
				console.log(error);
			}
		},

		async setFamilySettings({ commit }) {
			try {
				let res = await SettingsService.getFamilySettingsAsync();
				commit('setFamilySettings', res.Code === 200 ? res.Data : null);
			} catch (error) {
				console.log(error);
			}
		},

		async setChildSettings({ commit }) {
			try {
				let res = await SettingsService.getChildSettingsAsync();
				commit('setChildSettings', res.Code === 200 ? res.Data : null);
			} catch (error) {
				console.log(error);
			}
		},

		async setNotifSettings({ commit }) {
			try {
				let res = await SettingsService.getSettingsNotifAsync();
				commit('setSettingsNotif', res.Code === 200 ? res.Data : null);
				return res;
			} catch (error) {
				console.log(error);
			}
		},

		// eslint-disable-next-line no-unused-vars
		async saveNotifSettings({ commit }, notifications) {
			try {
				let res = await SettingsService.postSettingsNotifAsync(notifications);
				return res;
			} catch (error) {
				console.log(error);
			}
		},

		// eslint-disable-next-line no-unused-vars
		async updateSettings({ commit }, settings) {
			try {
				let res = await SettingsService.updateSettingsAsync(settings);
				return res;
			} catch (error) {
				console.log(error);
			}
		},

		setChosenOptionsFamilyElements({ commit }, elements) {
			commit('setFamilySettings', elements);
		},

		setChosenOptionsChildElements({ commit }, elements) {
			commit('setChildSettings', elements);
		},

		setFetchSettingsData({ commit }, value) {
			commit('setFetchSettings', value);
		}
	},
	//#endregion

	//#region [ Getters ]
	getters: {}
	//#endregion
};

export default settingsStore;
